import * as React from 'react';
const PressioneBassaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke-width:3px}.prefix__cls-1,.prefix__cls-2,.prefix__cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round}.prefix__cls-1,.prefix__cls-3{stroke:${primaryColor ||
        '#282828'}}.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'}}.prefix__cls-2,.prefix__cls-3{stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M98.3 126.4c2.02 3.03 4.58 5.74 7.77 7.5 3.59 1.98 8.04 2.63 11.85 1.11 3.8-1.52 6.71-5.43 6.46-9.52-.36-5.9-6.6-10.35-6.49-16.26.08-4.51 3.91-8.32 4.55-12.67"
      className="prefix__cls-1"
    />
    <path
      d="M93.39 128.55c2.98 4.59 7.1 8.51 12.15 10.57 5.62 2.3 12.44 2.03 17.39-1.49s7.45-10.49 5.08-16.07c-1.72-4.06-5.69-7.27-5.84-11.67-.16-4.61 4.04-8.62 4.46-13.02"
      className="prefix__cls-1"
    />
    <path
      d="M98.82 91.92c-4.54 8.47-12.13 15.32-21 19.04 2.55 4.78 5.4 9.4 8.52 13.82 5.59.27 11.04-2.26 15.24-5.95 2.83-2.49 5.16-5.48 7.21-8.66"
      className="prefix__cls-2"
    />
    <path
      d="M93.32 82.32a639.535 639.535 0 0 0 5.49 9.6c3.37 5.81 6.74 11.64 9.66 17.59.11.22.21.44.32.65.59 1.24 1.11 2.54 1.14 3.9.07 2.9-2.03 5.37-4.22 7.27a38.5 38.5 0 0 1-12.32 7.21c-.68.25-1.37.47-2.05.67-2.15.63-4.53 1.06-6.57.15-1.95-.86-3.21-2.75-4.37-4.54-3-4.67-6-9.34-9.01-14.01-.45-.71-.92-1.53-.69-2.33.26-.87 1.2-1.28 2.04-1.62 5.98-2.42 11.5-5.97 16.17-10.41.32-.3.64-.61.95-.94"
      className="prefix__cls-3"
    />
    <path
      d="M93.85 83.25c.14.32.26.66.36 1 .61 2.25.13 4.7-.94 6.77-.87 1.68-2.08 3.15-3.41 4.5a36.4 36.4 0 0 0-4.09-6.84c-5.86 6-12.99 11.2-21.23 12.73-1.39.26-2.84.4-4.22.07-1.09-.27-2.13-.89-2.78-1.79v-.01c-.17-.23-.3-.48-.41-.75-.79-2.04.46-4.27 1.79-6 4.36-5.7 10.18-10.27 16.75-13.13 3.32-1.45 6.95-2.47 10.53-1.94 3.22.48 6.36 2.46 7.65 5.39"
      className="prefix__cls-3"
    />
    <path
      d="M57.54 99.68c4.17 7.61 7.68 15.86 11.85 23.47 1.19 2.17 2.46 4.43 4.57 5.72 3.04 1.85 6.91 1.19 10.39.47"
      className="prefix__cls-3"
    />
    <path
      d="M116.96 65.88c-1.05.06-2.18.17-2.96.86-1.04.92-1.1 2.5-1.05 3.89.08 2.28.23 4.56.45 6.82.12 1.18.29 2.45 1.11 3.32.96 1.01 2.5 1.15 3.89 1.23l12.13.66c1.31.07 2.76.1 3.75-.77.76-.67 1.05-1.7 1.29-2.68.49-1.98.94-3.97 1.34-5.96.29-1.44.55-2.97.01-4.34-.65-1.67-2.4-2.72-4.16-3.03-1.76-.32-12.25-.2-15.8 0"
      className="prefix__cls-2"
    />
    <path
      d="M117.72 59.44c-3.8.29-7.84 1.88-9.62 5.25-1.67 3.17-.95 7.01-.2 10.51.95 4.36 1.89 8.73 2.84 13.09.53 2.46 1.21 5.15 3.25 6.62 1.54 1.11 3.55 1.29 5.44 1.43l9.41.69c2.28.17 4.77.28 6.63-1.06 1.78-1.28 2.49-3.54 3.07-5.65a237 237 0 0 0 4.1-17.66c.41-2.16.79-4.44.08-6.52-.88-2.58-3.33-4.37-5.93-5.18s-15.26-1.82-19.06-1.52Z"
      className="prefix__cls-2"
    />
    <path
      d="M118.8 87.04c.98-.51 2.33-.09 2.84.89.51.97.1 2.33-.87 2.85s-2.33.11-2.85-.86-.13-2.34.88-2.87ZM130.72 87.15c-1.06-.14-2.15.67-2.33 1.72s.58 2.17 1.62 2.4c1.04.22 2.2-.49 2.46-1.52.27-1.03-.35-2.41-1.75-2.6"
      className="prefix__cls-2"
    />
  </svg>
);
export default PressioneBassaIcon;
